import script from "./ProfileCreatorSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileCreatorSelector.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileCreatorSelector.vue?vue&type=style&index=0&id=7a98669b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a98669b"]])

export default __exports__